import React, { useState, useEffect } from "react";
import { Section, Container, Title } from "./styles";
import CircularPrograssbar from "./circularPrograssbar";
import { monitorCenterAPI } from "api";

const clampPct = (v?: number) =>
  typeof v === "number" ? Math.max(0, Math.min(100, v)) : 0;

const CircularMetricsPanel = ({ instance }) => {
  const [metricData, setMetricData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const apiData = await monitorCenterAPI.metric(instance);
      setMetricData(apiData.data);
    };

    fetchData();
    const interval = setInterval(async () => {
      await fetchData();
    }, 1000);

    return () => clearInterval(interval);
  }, [instance]);

  if (!metricData) return;

  return (
    <Section>
      <Title>VM Metrics</Title>
      <Container>
        <CircularPrograssbar
          metrics="CPU 사용량"
          value={clampPct(metricData.cpu)}
          accent="orange"
        />
        <CircularPrograssbar
          metrics="GPU 사용량"
          value={clampPct(metricData.gpu)}
          accent="violet"
        />
        <CircularPrograssbar
          metrics="GPU 메모리"
          value={clampPct(metricData.vram)}
          accent="indigo"
        />
        <CircularPrograssbar
          metrics="RAM 사용량"
          value={clampPct(metricData.ram)}
          accent="emerald"
        />
        <CircularPrograssbar
          metrics="DISK 사용량"
          value={clampPct(metricData.disk)}
          accent="sky"
        />
      </Container>
    </Section>
  );
};

export default CircularMetricsPanel;
